<template>
  <div class="search py-5">
    <div class="row mx-0">
      <div :class="{'col-11' : !noToggle, 'col-12' : noToggle }">
        <input type="text" class="form-control bg-dark border-dark text-white" v-model="search" placeholder="Поиск"/>
      </div>
      <div class="col-1" v-if="!noToggle">
        <b-button variant="info" class="btn-block" @click.prevent="toggleSearch">
          Закрыть
        </b-button>
      </div>
    </div>
    <div class="row mx-0 mt-4">
      <div class="col">
        <div class="columns-5 text-light" id="list">
          <div v-for="(m, k) in municipalities" :key="'list'+k" class="search-municipality">
            <span class="text-uppercase">{{ m }}</span>
            <div v-for="item in byMunicipality(m)" :key="item.SYS_GUID" @click="setChosen(item.SYS_GUID)" :class="{'search-ppe' : true, 'active' : item.SYS_GUID === chosen }">
              <b>{{ item.TYPE_OBJECT }}
                <template v-if="item.CODE_PPE_EGE">{{ item.CODE_PPE_EGE }} <small class="badge badge-pill badge-primary">ЕГЭ</small></template>
                <template v-if="item.CODE_PPE_OGE"> {{ item.CODE_PPE_OGE }} <small class="badge badge-pill badge-info">ОГЭ</small></template>
              </b>
              <br>
              {{ item.ADDRESS }}
              <br>
              <small class="search-ppe-title text-muted">{{ item.NAME_OO }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 border-left border-dark" v-if="!!chosen">
        <div class="d-flex flex-column pak-wrapper" v-if="!loading">
          <div class="text-white px-4 pb-3 border-bottom border-dark" v-if="Object.keys(chosenPPE).length > 0">
            <b>{{ chosenPPE.TYPE_OBJECT }}
              <template v-if="chosenPPE.CODE_PPE_EGE">{{ chosenPPE.CODE_PPE_EGE }} <small class="badge badge-pill badge-primary">ЕГЭ</small></template>
              <template v-if="chosenPPE.CODE_PPE_OGE"> {{ chosenPPE.CODE_PPE_OGE }} <small class="badge badge-pill badge-info">ОГЭ</small></template>
            </b>
            <br>
            {{ chosenPPE.ADDRESS }}
            <br>
            <span>{{ chosenPPE.NAME_OO }}</span>
          </div>
          <ul class="list-unstyled text-light px-4" v-if="pak.length > 0" id="pak">
            <li :class="{'pak p-2' : true, 'disabled' : selected.includes(item.SYS_GUID)}" v-for="item in pak" :key="item.SYS_GUID">
              <a class="text-decoration-none text-white" href="#"  @click.prevent="selectPak(item)">
                <b>{{ item.TYPE_PAK }}</b> <span :class="{ 'badge badge-pill' : true, 'badge-primary' : item.USAGE === '1', 'badge-info' : item.USAGE !== '1' } " v-text="item.USAGE === '1' ? 'ЕГЭ' : 'ОГЭ'"></span> <span class="text-success online" v-if="item.STREAM_STATUS === 'started'">Онлайн</span>
                <br>
                <span class="text-muted">
                  Аудитория {{ item.room.CLASSROOM }} <span v-if="item.room.CODE_CLASSROOM">({{ item.room.CODE_CLASSROOM }})</span>
                </span>
                <small v-if="canControlStream">&nbsp;&nbsp;&nbsp;{{ item.IP_ADDRESS }}</small>
              </a>
            </li>
          </ul>
          <p class="text-muted text-center py-5" v-else>Ничего не найдено</p>
        </div>
        <div class="h-100 d-flex justify-content-center align-items-center text-muted" v-else>
          <font-awesome-icon :icon="['fas', 'spinner']" pulse class="fa-3x text-muted"></font-awesome-icon>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import { apiQuery } from "../api";
  import _ from 'lodash'
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';
  import Vuex from 'vuex'

  export default {
    name: "Search",
    props: {
      noToggle: Boolean,
      selected: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        ppe: [],
        pak: [],
        sbppe: null,
        sbpak: null,
        loading: true,
        municipality: '',
        search: '',
        chosen: null
      }
    },
    watch: {
      chosen() {
        this.loadPak()
      },
      search() {
        if (this.sbppe)
          this.sbppe.update()
        document.querySelector('#list').scrollLeft = 0
        this.setFilter(this.search)
      }
    },
    computed: {
      ...Vuex.mapGetters([
        'canControlStream',
        'canOgeOnline',
        'canEgeOnline',
        'canOgeArchive',
        'canEgeArchive',
        'getFilter',
      ]),
      municipalities() {
        let items = this.filtered.map(item => Object.prototype.hasOwnProperty.call(item, 'COMMUNITY') ? item.COMMUNITY : 'Не указано')
        return _.uniq(items)
      },
      filtered() {
        let items = this.ppe
        if (this.search.length > 0) {
          let srch = this.search.toLowerCase().trim()
          let filter = srch.split(' ')
          if (srch.match(/ппэ \d+/)) {
            let term = srch.replace('ппэ', '').trim()
            items = items.filter(row => Object.keys(row).some(key => {
                    if (['CODE_PPE_EGE', 'CODE_PPE_OGE'].includes(key))
                      return String(row[key]).toLowerCase() === term
                    else
                      return false
                }
            ))
          }
          else {
            filter.map(term => {
              items = items.filter(row => Object.keys(row).some(key => {
                if (['ADDRESS', 'AREA', 'CODE_OO', 'CODE_PPE_OGE', 'CODE_PPE_EGE', 'COMMUNITY', 'TYPE_OBJECT'].includes(key))
                  return String(row[key]).toLowerCase().indexOf(term) > -1
                else
                  return false

                }
              ))
            })
          }
        }
        return items
      },
      chosenPPE() {
        if (this.chosen) {
          return this.ppe.find(ppe => ppe.SYS_GUID === this.chosen)
        }
        else return {}
      }
    },
    mounted() {
      let params = {
        table: window.x2.tables.schools,
        selectFields: ['SYS_GUID', 'COMMUNITY', 'NAME_OO', 'ADDRESS', 'CODE_PPE_EGE', 'CODE_PPE_OGE'],
        sort: [{ field: 'COMMUNITY', dir: 'ASC' }],
      }
     if (( !this.noToggle && !this.canEgeOnline ) || ( this.noToggle && !this.canEgeArchive )) {
        params.filter = [{
            field: "CODE_PPE_OGE",
            inverse: true,
            operator: "isnull",
            type: "simple"
          }]
      }
      if (( !this.noToggle && !this.canOgeOnline ) || ( this.noToggle && !this.canOgeArchive )) {
        params.filter = [{
            field: "CODE_PPE_EGE",
            inverse: true,
            operator: "isnull",
            type: "simple"
          }]
      }
      apiQuery('private', 'data-get-records', params, false).then(response => {
        let result = response.count === 0 ? [] : response.rows
        if (( !this.noToggle && !this.canEgeOnline ) || ( this.noToggle && !this.canEgeArchive )) {
          this.ppe = result.filter(s => Object.prototype.hasOwnProperty.call(s,'CODE_PPE_OGE'))
        }
        else if (( !this.noToggle && !this.canOgeOnline ) || ( this.noToggle && !this.canOgeArchive )) {
          this.ppe = result.filter(s => Object.prototype.hasOwnProperty.call(s,'CODE_PPE_EGE'))
        }
        else {
          this.ppe = result
        }
        this.loading = false
        this.search = this.getFilter
        setTimeout(() => { this.sbppe = new PerfectScrollbar('#list', { wheelPropagation: false, suppressScrollY: true, useBothWheelAxes: true, wheelSpeed: 5 }) }, 100);
      })
    },
    methods: {
      ...Vuex.mapMutations([
        'toggleSearch',
        'setFilter'
      ]),
      setChosen(val) {
        this.chosen = val
      },
      async loadPak() {
        this.loading = true
        this.sbppe.update()
        let filters = {}
        if (( !this.noToggle && !this.canEgeOnline ) || ( this.noToggle && !this.canEgeArchive )) {
          filters = [{
            field: "TYPE_CLASSROOM",
            inverse: false,
            operator: "eq",
            type: "simple",
            value: "OGE"
          }]
        }
        if (( !this.noToggle && !this.canOgeOnline ) || ( this.noToggle && !this.canOgeArchive )) {
          filters = [{
            field: "TYPE_CLASSROOM",
            inverse: false,
            operator: "eq",
            type: "simple",
            value: "EGE"
          }]
        }

        let roomQueries = [];
        if ((!this.noToggle && this.canOgeOnline) || (this.noToggle && this.canOgeArchive)) {
          roomQueries.push(
            apiQuery('private', 'data-get-records', {
              table: window.x2.tables.rooms,
              filter: filters,
              sort: [{
                field: 'CODE_CLASSROOM',
                dir: 'ASC'
              }],
              context: {
                state: {
                  [window.x2.tables.schools]: this.chosen
                }
              }
            }, false).then(r => r.rows)
          )
        }
        if ((!this.noToggle && this.canEgeOnline) || (this.noToggle && this.canEgeArchive)) {
          roomQueries.push(
            apiQuery('private', 'data-get-records', {
              table: window.x2.tables.egerooms,
              filter: filters,
              sort: [{
                field: 'DATE',
                dir: 'DESC'
              }],
              context: {
                state: {
                  [window.x2.tables.schools]: this.chosen
                }
              }
            }, false).then(r => r.rows)
          )
        }
        let rooms = await Promise.all(roomQueries)
        rooms = rooms.reduce((res, row) => res.concat(row), [])
        if (rooms.length > 0) {
          let pak = await Promise.all(
            rooms.map(room => {
              return apiQuery('private', 'data-get-records', {
                table: room.TYPE_CLASSROOM === 'OGE' ? window.x2.tables.pak : window.x2.tables.pakege,
                context: {
                  state: {
                    [room.TYPE_CLASSROOM === 'OGE' ? window.x2.tables.rooms : window.x2.tables.egerooms]: room.SYS_GUID
                  }
                }
              }, false).then(r => {
                r.rows.map(row => row.room = room)
                return r.rows
              })
            })
          )
          pak = pak.reduce((res, row) => res.concat(row), [])
          this.pak = pak
        } else {
          this.pak = []
        }

        if (this.pak.length > 0) {
          setTimeout(() => {
            new PerfectScrollbar('#pak', {wheelPropagation: false, wheelSpeed: 1, suppressScrollX: true, useBothWheelAxes: true})
          }, 100)
        }
        this.loading = false
      },
      selectPak(pak) {
        pak['org'] = this.ppe.find(item => item.SYS_GUID === this.chosen)
        this.$emit('select', pak)
        if (!this.noToggle)
          this.toggleSearch()
      },
      byMunicipality(m) {
          let items = this.filtered
          if (m && m.length > 0) {
            if (m === 'Не указано')
              items = items.filter(item => !Object.prototype.hasOwnProperty.call(item, 'COMMUNITY') || item.COMMUNITY === '' || item.COMMUNITY === null )
            else
              items = items.filter(item => Object.prototype.hasOwnProperty.call(item, 'COMMUNITY') && item.COMMUNITY === m)
          }
          return items
      },
    }
  }
</script>


